import React from 'react';

import { isRovoSystemSpaceKey } from '@confluence/route-manager/entry-points/isRovoSystemSpaceKey.ts';
import { NotFound } from '@confluence/not-found/entry-points/NotFound.ts';
import { fg } from '@confluence/feature-gating';

type WithRovoSystemSpaceNotFoundProps = {
	spaceKey: string;
};

export const withRovoSystemSpaceNotFound = <T extends WithRovoSystemSpaceNotFoundProps>(
	Component: React.ComponentType<T>,
): React.ComponentType<T> => {
	return (props: T) => {
		// eslint-disable-next-line confluence-feature-gating/no-preconditioning
		if (fg('aifc_create_enabled') && isRovoSystemSpaceKey(props.spaceKey)) {
			return <NotFound />;
		}
		return <Component {...props} />;
	};
};
